module.exports = __webpack_public_path__ + "static/media/csengo.c93eb697.svg";